import React from 'react';
import { Info, TriangleAlert } from 'lucide-react';
import { cn } from '../../lib/utils';

const TONES = {
  warning: { className: 'border-warning/40 bg-warning/10 text-foreground', Icon: TriangleAlert },
  info: { className: 'border-primary/30 bg-primary/5 text-foreground', Icon: Info },
} as const;

interface ChatNoticeProps {
  tone: keyof typeof TONES;
  children: React.ReactNode;
  className?: string;
}

/** A caveat attached to an answer — why it fell back, what it could not check. */
const ChatNotice: React.FC<ChatNoticeProps> = ({ tone, children, className }) => {
  const { className: toneClass, Icon } = TONES[tone];

  return (
    <div
      role="status"
      className={cn(
        'mt-2 flex items-start gap-2 rounded-lg border px-2.5 py-1.5 text-xs leading-relaxed',
        toneClass,
        className,
      )}
    >
      <Icon
        className={cn(
          'mt-0.5 size-3.5 shrink-0',
          tone === 'warning' ? 'text-warning' : 'text-primary',
        )}
        strokeWidth={2}
      />
      <span>{children}</span>
    </div>
  );
};

export default ChatNotice;
